/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

import FormItem from 'components/FormFields/FormItem';
import Select from 'components/FormFields/Select';
import './form-select.scss';

const FormSelect = (props) => {
  const {
    name,
    className,
    id,
    wrapperProps,
    labelProps,
    labelHidden = false,
    showSearch = false,
    required,
    children,
    dropdownButtonProps,
    emptyValue = 'Select...',
    ...restProps
  } = props;

  // Strip special chars and replace spaces with - for id.
  const elementId = id ?? name.replace(/[^a-zA-Z0-9 ]/g, '').replace(' ', '-').toLowerCase();

  const { className: wrapperClasses, ...restWrapper } = wrapperProps || {};

  return (
    <FormItem
      id={elementId}
      name={name}
      type="select"
      required={required}
      className={wrapperClasses}
      labelProps={labelProps}
      labelHidden={labelHidden}
      {...restWrapper}
    >
      <Select
        showSearch={showSearch}
        required={required}
        emptyValue={emptyValue}
        className={className}
        dropdownButtonProps={dropdownButtonProps}
        {...restProps}
      >
        {children}
      </Select>
    </FormItem>
  );
};

FormSelect.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

export default FormSelect;
